import "./App.css";
import Home from "./Screens/Home";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import PortalLayout from "./layouts/PortalLayout";
import Employees from "./Screens/Employees/Employees";
import EmployeesAddEdit from "./Screens/Employees/EmployeesAddEdit";
import Login from "./Screens/Login/Login";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import TopUsers from "./Screens/TopUsers/TopUsers";
import UserDetails from "./Screens/UserDetails/UserDetails";
import Subscription from "./Screens/Subscription/Subscription";
import Notification from "./Screens/Notification/Notification";
import ChatSupport from "./Screens/Profiles/Profiles";
import Profiles from "./Screens/Profiles/Profiles";
import Registration from "./Screens/Registration/Registration";
import Chats from "./Screens/Chat/Chat";
import ForgotPassword from "./Screens/ForgotPassword/ForgotPassword";
import Blogs from "./Screens/blogs/Blogs";
import UserProfiles from "./Screens/UserProfiles/UserProfiles";
import AppVersion from "./Screens/AppVersion/AppVersion";
import MatchUsers from "./Screens/MatchUser/MatchUser";
import AdminPanelUsers from "./Screens/AdminPanelUsers/AdminPanelUsers";
import BoostHistory from "./Screens/BoostHistory/BoostHistory";
import PromotionalMessage from "./Screens/PromotionalMessage/PromotionalMessage";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate("/login");
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    setIsAuthenticated(localStorage.getItem("naseebiAdmin"));
  }, [location.pathname]);

  return (
    <PortalLayout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Home />} />
        <Route path="/users" element={<Employees />} />
        <Route path="/topusers" element={<TopUsers />} />
        <Route path="/user-profiles" element={<UserProfiles />} />
        <Route path="/userdetails/:id" element={<UserDetails />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/promotional-messages" element={<PromotionalMessage />} />
        <Route path="/profiles" element={<Profiles />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/app-version" element={<AppVersion />} />
        <Route path="/match-user" element={<MatchUsers />} />
        <Route path="/admin-panel-users" element={<AdminPanelUsers />} />
        <Route path="/boost-history" element={<BoostHistory />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/*<Route path="users/add" element={<EmployeesAddEdit />} />*/}
        {/*<Route path="users/edit" element={<EmployeesAddEdit edit={true} />} />*/}
      </Routes>
    </PortalLayout>
  );
}

export default App;
